import moment from 'moment'
import { nanoid, customAlphabet } from 'nanoid'
import { useState } from 'react'
export const keys = {
  groupIdKey: '_id',
  groupTitleKey: 'title',
  groupRightTitleKey: 'rightTitle',
  itemIdKey: '_id',
  itemTitleKey: 'title',
  itemDivTitleKey: 'title',
  itemGroupKey: 'group',
  itemTimeStartKey: 'start_time',
  itemTimeEndKey: 'end_time',
  groupLabelKey: 'title'
}
export const minTime = moment()
  .add(-7, 'months')
  .valueOf()
export const maxTime = moment()
  .add(6, 'months')
  .valueOf()

export const defaultTimeStart = moment()
  .startOf('month')
  .toDate()
export const defaultTimeEnd = moment()
  .startOf('month')
  .add(30, 'day')
  .toDate()
// export const defaultTimeStart = moment()
//   .startOf('day')
//   .add(5, 'hour')
//   .toDate()
// export const defaultTimeEnd = moment()
//   .startOf('day')
//   .add(1, 'day')
//   .add(-3, 'hour')
//   .toDate()

export function randomInt (min, max) {
  const nanoid = customAlphabet('123456789', 6)
  const nid = nanoid() //=> "4f90d13a42"
  return nid
  //return min + Math.floor((max - min) * Math.random())
}
